export const QUICKBOOKS = 'QuickBooks'
export const NETSUITE = 'NetSuite'
export const XERO = 'Xero'
export const SAGE_INTACCT = 'Sage Intacct'
export const CUSTOM_ERP_MAPPING = 'Custom ERP Mapping'

export const ACCOUNTING_APP_TO_MERGE_INTEGRATION_NAME = {
  [QUICKBOOKS]: 'quickbooks-online',
  [NETSUITE]: 'netsuite',
  [XERO]: 'xero',
  [SAGE_INTACCT]: 'sage-intacct',
}

export const ACCOUNTING_APP_TO_INTEGRATION_NAME = {
  [QUICKBOOKS]: 'QuickBooks',
  [NETSUITE]: 'NetSuite',
  [XERO]: 'Xero',
  [SAGE_INTACCT]: 'SageIntacct',
}

export const MERGE_ACCOUNTING_APPS = [QUICKBOOKS, NETSUITE, XERO, SAGE_INTACCT]
